import { useColorContext } from '../contexts/ColorContext';
import { useColorActions } from '../hooks/useColorActions';
import { PrintToolsPanel } from '../components/PrintToolsPanel';

export function PrintTool() {
  const { result, selectedCmykProfile, handleSelectProfile, copiedField, copyToClipboard } = useColorContext();
  const { setActiveColor } = useColorActions();

  if (!result) {
    return <div style={{ padding: '48px 0', textAlign: 'center', color: 'var(--ink-3)', fontSize: 13 }}>Enter a valid color for print analysis.</div>;
  }

  return (
    <PrintToolsPanel
      result={result}
      selectedProfileId={selectedCmykProfile}
      onSelectProfile={handleSelectProfile}
      copiedField={copiedField}
      onCopy={copyToClipboard}
      onSetActive={(hex) => setActiveColor({ hex })}
    />
  );
}
